<div class="row site-row">
  <div
    fxFlex="100%"
    fxFlex.xs="100%"
    fxLayout="row wrap"
    fxLayout.xs="column"
    fxLayout.sm="column"
    fxLayoutAlign="flex-start flex-start"
    class="site-panel"
    id="site-panel-header"
  >
    <div fxFlex="40%;" fxFlex.xs="40%" class="site-name-info">
      {{ model.siteName }}, {{ model.city }}
    </div>
  </div>
</div>
<div class="row site-row main-content">
  <mat-tab-group
    id="site-master-tab"
    class="site-master-tab"
    dynamicHeight
    [(selectedIndex)]="activeTabIndex"
    (selectedTabChange)="navigate($event)"
  >
    <mat-tab *ngFor="let tab of lineManagementTabs" [disabled]="tab.disable">
      <ng-template mat-tab-label>
        <mat-icon [id]="tab.id" [ngClass]="tab.iconClass"></mat-icon> &nbsp;
        <span (click)="tabClick(tab)">{{ tab.label }}</span>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
